import {$http} from "@/plugins/axios"

export function fileUrl(id: number, preview: boolean = false): string {
  const url = new URL(`${import.meta.env.VITE_APP_URL}${import.meta.env.VITE_API_BASE_URL}/file-urls/${id}`)

  if (preview) {
    url.searchParams.set('preview', 'true')
  }

  url.searchParams.set('token', localStorage.getItem('token') || '')

  return url.toString()
}

export function downloadFile(id: number): Promise<any> {
  return $http.download(fileUrl(id), {
    download: true
  })
}

export function formatFileSize(size: number): string {
  if (size == 0) {
    return "0 KB"
  }

  const i = Math.floor(Math.log(size) / Math.log(1024))

  const item = size / Math.pow(1024, i)

  return item.toFixed(2) + " " + ["B", "KB", "MB", "GB"][i]
}
